import React from 'react';
import './PageHeader.css';

export default function PageHeader({ title, description, actions }) {
  return (
    <div className="admin-page-header-container">
      <div className="header-titles-column">
        <h2 className="header-title-text">{title}</h2>
        {description && <p className="header-description-text">{description}</p>}
      </div>
      
      {/* 🌟 Dynamic action portal container to position upload pills or action buttons inline */}
      {actions && <div className="header-actions-wrapper">{actions}</div>}
    </div>
  );
}